'use strict';

(function () {
  'use strict';

  angular.module('msCore').component('msFooter', {
    templateUrl: 'core/templates/ms-footer.html',
    controller: MsFooterController,
    controllerAs: 'vm',
    bindings: {
      isDisclaimer: '<',
      isApiVersionHidden: '<',
      isLanding: '<',
      isOnboarding: '<',
      isAppFeedback: '<'
    }
  });

  MsFooterController.$inject = ['languageSvc', 'agreementsSvc', '$translate', 'providerSvc', 'NotifyingSvc', '$injector', '$scope'];

  function MsFooterController(languageSvc, agreementsSvc, $translate, providerSvc, NotifyingSvc, $injector, $scope) {
    var vm = this;
    vm.$onInit = activate;
    vm.appMode = 'STANDARD';

    vm.getTranslation = function (key) {
      return $translate.instant('onboarding.account.checkboxTerms.titlesShort.' + key);
    };

    function activate() {
      vm.setAgreements();
    }

    vm.setAgreements = function (event, force) {
      if (vm.isOnboarding) {
        vm.authenticationSvc = $injector.get('authenticationSvc');
        vm.ssoInfo = vm.authenticationSvc.getCurrentSsoInfo();
        if (vm.ssoInfo) {
          vm.ssoAccessCode = vm.ssoInfo.attributesView.accessCode;
        }
      }

      vm.accessCode = providerSvc.getProvider().accessCode;
      vm.currentLanguage = languageSvc.getLanguage();

      if (!vm.accessCode && !event && !vm.ssoAccessCode) {
        agreementsSvc.getAgreementsByCode(vm.currentLanguage).then(function (agreements) {
          vm.agreements = agreements;
        });
        return;
      }

      var userAccessCode = vm.accessCode || vm.ssoAccessCode;

      agreementsSvc.getAgreementsByCode(vm.currentLanguage, userAccessCode, force).then(function (agreements) {
        vm.agreements = agreements;
      });

      if (userAccessCode) {
        providerSvc.getAccessCodeByName(userAccessCode).then(function (resp) {
          vm.appMode = resp.data.applicationMode.name;
        });
      }
    };

    NotifyingSvc.subscribe(NotifyingSvc.EVENTS.GET_AGREEMENTS, vm.setAgreements, $scope);
  }
})();